export default __webpack_public_path__ + "static/media/Ahmad.50ad85d9.jpg";